module.exports = __webpack_public_path__ + "static/media/mobile_capy_page_area01_img_en@2x.d04b41be.png";